import React, { useEffect, useRef } from 'react';

const useOutsideClick = (ref, buttonRef, cb) => {
  const isTargetOutside = (elRef, event) =>
    elRef.current && !elRef.current.contains(event.target);

  const handleOutsideClick = event => {
    if (isTargetOutside(ref, event) && isTargetOutside(buttonRef, event)) {
      typeof cb === 'function' && cb();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  });
};

const OutsideClickNotifier = props => {
  const wrapperRef = useRef(null);
  useOutsideClick(wrapperRef, props.buttonRef, props.toggleShow);

  return React.cloneElement(props.children, { wrapperRef });
};

export default OutsideClickNotifier;
